document.addEventListener('DOMContentLoaded', () => {
  const modal = document.getElementById('manuals-modal');
  const openBtn = document.querySelector('.js-open-manuals-modal');
  const closeTriggers = modal ? modal.querySelectorAll('.js-manuals-modal-close') : [];

  function openModal() {
    if (!modal) return;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
    const firstLink = modal.querySelector('.manuals-modal__link');
    if (firstLink) firstLink.focus();
  }

  function closeModal() {
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
    if (openBtn) openBtn.focus();
  }

  if (openBtn && modal) {
    openBtn.addEventListener('click', e => {
      e.preventDefault();
      openModal();
    });

    closeTriggers.forEach(btn => {
      btn.addEventListener('click', e => {
        e.preventDefault();
        closeModal();
      });
    });

    const overlay = modal.querySelector('.manuals-modal__overlay');
    if (overlay) overlay.addEventListener('click', closeModal);

    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
    });
  }
});
